import * as React from 'react';
import styled from 'styled-components';
import { CourseProps } from 'Jsx/Shared/CourseCardV3/types';

import getImgxUrl from 'Jsx/Utils/getImgxUrl';

import CourseCardV3Wrapper from './CourseCardV3Wrapper';
import {
  Image,
  CardBody,
  Title,
  Enrollments,
  Prices,
  AddToCart,
  AddToPack,
  TagMobile,
} from '../components';
import CustomWrapper from '../utils/CustomWrapper';

const Root = styled.div<{ dark?: boolean }>`
  .CourseCardComponent {
    display: flex;
    flex-direction: row;
  }
  .TitleComponentText {
    line-height: 16px;
  }
  .PricesComponent {
    margin-top: 8;
  }
  .ImageComponent {
    width: 80px !important;
    height: auto !important;
  }
  .CardBodyComponent {
    ${props => props.dark && 'background-color: transparent !important;'}
    display: flex;
    flex-direction: column;
    margin-left: 8px;
    @media (min-width: 768px) {
      height: 96px;
    }
  }
  .EnrollmentsComponent {
    margin-top: 8;
    margin-bottom: 0;
  }
`;

const CourseCardV3Mobile: React.FC<CourseProps> = ({
  customBundle,
  ...props
}) => {
  const { user, dark } = props;

  const userIsPremium = user && user.isPremiumMember;

  return (
    <Root dark={dark}>
      <CourseCardV3Wrapper {...props} isMobileCard hideSoftware responsiveImage>
        <CustomWrapper className="flex flex-col">
          <CustomWrapper className="flex">
            <Image
              lazyImageProps={{
                sources: {
                  default: getImgxUrl(
                    (props.promoImage || props.promoImageAnimated) as string,
                    { w: 80, h: 60 },
                  ),
                  sm: getImgxUrl(
                    (props.promoImage || props.promoImageAnimated) as string,
                    { w: 120, h: 80 },
                  ),
                  md: getImgxUrl(
                    (props.promoImage || props.promoImageAnimated) as string,
                    { w: 240, h: 160 },
                  ),
                },
                alt: props.title,
              }}
            />
            <CardBody isMobile>
              <TagMobile />
              <Title />
              {customBundle || userIsPremium ? <Enrollments /> : <Prices />}
            </CardBody>
          </CustomWrapper>
          {customBundle ? <AddToPack /> : <AddToCart />}
        </CustomWrapper>
      </CourseCardV3Wrapper>
    </Root>
  );
};

export default CourseCardV3Mobile;
